export const TEAM = [
  {
    name: "Girish Konattu",
    role: "Chief Executive Officer",
    short: "C.E.O",
    photo: "https://static.wixstatic.com/media/da3b64_036e4734c2894702a4fb89a927e08139~mv2.png",
  },
  {
    name: "Sooraj S Nair",
    role: "Chief Operating Officer",
    short: "C.O.O",
    photo: "https://static.wixstatic.com/media/da3b64_97d95584c9384327882e06169fa4508c~mv2.png",
  },
  {
    name: "Vinod Kumar C.G",
    role: "General Manager · Home Appliances",
    short: "GENERAL MANAGER",
    photo: "https://static.wixstatic.com/media/da3b64_49b297253f244bd1b6574362a339016e~mv2.png",
  },
  {
    name: "Santhosh C.K",
    role: "Human Resources Manager",
    short: "H.R MANAGER",
    photo: "https://static.wixstatic.com/media/da3b64_7964bd07fcde499298a86589ce844743~mv2.png",
  },
];

export const TESTIMONIALS = [
  {
    name: "Agin Varghese",
    quote:
      "Impressed by Konattu Group's extensive range, I find all I need under one roof. Quality and convenience redefine my shopping experience.",
  },
];
